import { usePolledCount } from './usePolledCount.js';

/**
 * `UNREAD_CHATS_QUERY` off the BFF while `enabled` (session ready + widget
 * closed): the same number `useChatsUnreadCount` reads live once connected,
 * polled so a closed widget on every host page costs no MAU or connection.
 * Falls the moment an employer reads, unlike `usePendingReplies`.
 */
export function useUnreadCount(enabled: boolean): number | null {
  return usePolledCount('/api/chat/unread', enabled);
}
